import styled, { keyframes } from "styled-components";

/* ── paleta do design system ── */
const TEAL = 'var(--teal)';
const CORAL = 'var(--coral)';
const RED_SOFT = 'rgba(207, 58, 58, 0.18)';

const bp = { nav: '850px', tablet: '768px', mobile: '540px' };

const rotateLogo = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

export const Container = styled.header`
  position: sticky;
  top: 0;
  z-index: 900;
  background: linear-gradient(180deg, ${TEAL} 0%, #00343f 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.18);
  padding: 6px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  .logoHome {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 800;
    letter-spacing: 0.3px;
    color: #f7f9fc;
    gap: 8px;
    flex-shrink: 0;

    .text-desktop { display: none; }

    @media (min-width: 770px) {
      .text-mobile { display: none; }
      .text-desktop { display: inline; }
    }

    svg {
      height: 56px;
      width: 56px;
      color: ${CORAL};
      animation: ${rotateLogo} 70s linear infinite;
    }

    img { height: 50px; width: 55px; }

    @media (max-width: ${bp.tablet}) {
      font-size: 15px;
      width: auto;
      justify-content: flex-start;
      img { height: 40px; width: 45px; }
      svg { height: 42px; width: 42px; }
    }
  }

  @media (max-width: ${bp.tablet}) { padding: 6px 12px; }

  /* ── navegação desktop ── */
  .desktop-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    min-width: 0;

    nav {
      display: flex;
      gap: 0.4rem;
      flex-wrap: wrap;
      justify-content: center;

      a {
        color: #d4e0e6;
        font-size: 14.5px;
        font-weight: 600;
        position: relative;
        text-decoration: none;
        padding: 8px 12px;
        border-radius: 9px;
        transition: color 0.18s ease, background 0.18s ease;

        &:before {
          content: '';
          position: absolute;
          width: 0%;
          height: 2px;
          background: ${CORAL};
          bottom: 2px;
          left: 12px;
          transition: width 0.25s ease;
        }

        &:hover {
          color: #ffffff;
          background: rgba(255, 255, 255, 0.08);
        }
        &:hover:before { width: calc(100% - 24px); }
      }

      .nav__link.active {
        color: #ffffff;
        background: rgba(224, 122, 95, 0.18);
        font-weight: 700;
        &:before { width: calc(100% - 24px); }
      }
    }

    @media (max-width: ${bp.nav}) { display: none; }
  }

  .desktop-user-info {
    display: flex;
    align-items: center;
    @media (max-width: ${bp.nav}) { display: none; }
  }

  .theme-toggle-slot {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  .mobile-icon {
    display: none;
    font-size: 28px;
    color: #fff;
    cursor: pointer;
    padding: 6px;
    border-radius: 9px;
    transition: background 0.18s ease;
    &:hover { background: rgba(255, 255, 255, 0.1); }
    @media (max-width: ${bp.nav}) { display: block; }
  }
`;

/* ⚠️ 'Name' e 'Span' antes de 'Emp' (referência em &:hover) */
export const Name = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #eef4f6;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
  transition: color 0.18s ease, text-shadow 0.18s ease;
  @media (max-width: ${bp.tablet}) { font-size: 12px; }
`;

export const Span = styled.span`
  font-size: 11.5px;
  font-weight: 600;
  color: #9fb4bc;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
  transition: color 0.18s ease, text-shadow 0.18s ease;
  @media (max-width: ${bp.tablet}) { font-size: 11px; }
`;

export const PerfilIndicador = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #9fb4bc;
  margin: 0;
  padding: 0;
  transition: color 0.18s ease;

  svg { font-size: 14px; }
  p { margin: 0; padding: 0; font-size: 11px; font-weight: 700; }
`;

/* avatar de iniciais (opcional, usado no lugar da ProfilePhoto) */
export const Avatar = styled.div`
  width: 38px;
  height: 38px;
  min-width: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 800;
  color: #fff;
  text-transform: uppercase;
`;

export const Emp = styled.div`
  width: auto;
  max-width: 250px;
  align-items: center;
  padding: 5px 10px;
  margin: 0 6px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: background 0.18s ease;

  &:hover { background: rgba(255, 255, 255, 0.08); }

  /* hover acende nome, spans e indicador */
  &:hover ${Name} { color: #ffffff; }
  &:hover ${Span} { color: #d4e0e6; }
  &:hover ${PerfilIndicador},
  &:hover ${PerfilIndicador} svg,
  &:hover ${PerfilIndicador} p { color: ${CORAL}; }
  &:hover ${PerfilIndicador} svg { transform: translateY(-1px); }
`;

export const EmployeeInfo = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Pro = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const ProfilePhoto = styled.div`
  width: 40px;
  height: 40px;
  background-color: var(--line);
  border-radius: 50%;

  @media (max-width: ${bp.tablet}) { width: 36px; height: 36px; }
`;

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  min-width: 0;
`;

export const DivButtomEdit = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  flex-shrink: 0;
  @media (max-width: ${bp.nav}) { display: none; }
`;

export const Btt02 = styled.button`
  background: rgba(255, 255, 255, 0.08);
  color: #eef4f6;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 9px;
  padding: 8px 16px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.18s ease, border-color 0.18s ease, transform 0.12s ease;

  &:hover {
    background: ${RED_SOFT};
    border-color: rgba(207, 58, 58, 0.4);
    color: #ffd9d4;
    transform: translateY(-1px);
  }
`;